export const isProduction = process.env.NODE_ENV === 'production';
export const isDev = process.env.NODE_ENV !== 'production';
